<template>
  <el-dialog title="价格说明" :visible="visible" class="dialog-price" append-to-body width="480px">
    <div class="price-content">
      <div class="dialog-title">价格说明</div>
      <div class="price-content-dom">
        <div style="margin-left: 24px">
          <div class="price-table">
            <div class="price-list">
              <span class="vip-name">会员等级</span>
              <span class="vip-price">享受会员价</span>
            </div>
            <div class="price-list" v-for="item in vip_list" :key="item.id">
              <span class="vip-name">{{ item.name }}</span>
              <span class="vip-price">
                <CurrencyNew
                  :showFreeText="true"
                  :price="item.vip_price || 0"
                  :priceTwo="true"
                  :isUnderlineLeft="false"
                ></CurrencyNew>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="cancel">我知道了</el-button>
      <el-button type="primary" @click="confirm" v-if="!checkIsVip()"> 开通会员 </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'VipPrice',
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      visible: false,
      vip_list: [],
    };
  },
  watch: {
    isShow(value) {
      this.visible = value;
      if (value) {
        this.getLevelList();
      }
    },
  },
  methods: {
    //会员等级列表
    async getLevelList() {
      const res = await this.$http.get('/api/app/practice/discount/' + this.$route.query.id);
      this.vip_list = res || [];
    },
    cancel() {
      this.visible = false;
      this.$emit('update:isShow', false);
    },
    confirm() {
      this.$router.push({
        name: 'Vip',
      });
    },
    //判断会员是否过期
    getIsExpire(time) {
      if (time) {
        const now = this.$actionTool.getCurTimestamp(); //当前时间的时间戳
        if (now > time) {
          //如果当前时间大于会员到期时间，说明已过期
          return false;
        }
      }
      return true;
    },
    //判断是否是会员
    checkIsVip() {
      const userInfo = this.$store.state.user_info || {};
      if (
        userInfo.vip_info &&
        userInfo.vip_info.name &&
        this.getIsExpire(userInfo.vip_info.end_at)
      ) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style scoped lang="scss">
.dialog-price {
  ::v-deep .el-dialog__header {
    display: none;
  }
  ::v-deep .el-dialog__footer {
    padding: 28px 24px 24px 18px;
  }
  ::v-deep .el-dialog__body {
    padding: 16px 0 0 0;
  }
  .dialog-title {
    padding: 0 24px;
    height: 24px;
    font-size: 18px;
    font-family: PingFang SC, PingFang SC-Medium;
    font-weight: 500;
    color: #333333;
    line-height: 24px;
    margin-bottom: 28px;
  }
  .price-content-dom {
    max-height: 420px;
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 0 !important;
    }
    & {
      -ms-overflow-style: none;
    }
    & {
      overflow: -moz-scrollbars-none;
    }
  }
  .price-table {
    width: 432px;
    margin: 160x 0 28px 0;
    border: 1px solid #dbdbdb;
    border-radius: 8px 8px 0px 0px;
    .price-list {
      border-bottom: 1px solid #dbdbdb;
      height: 48px;
      line-height: 48px;
      font-size: 14px;
      font-family: PingFang SC, PingFang SC-Medium;
      &:last-child {
        border-bottom: none;
      }
      .vip-name {
        text-align: center;
        display: inline-block;
        width: 215px;
        border-right: 1px solid #dbdbdb;
        font-weight: 400;
        color: #666666;
        overflow: hidden; /*超出部分隐藏*/
        white-space: nowrap; /*不换行*/
        text-overflow: ellipsis; /*超出部分文字以...显示*/
      }
      .vip-price {
        display: inline-block;
        text-align: center;
        display: inline-block;
        width: 215px;
        font-weight: 500;
        color: #a37f23;

        overflow: hidden; /*超出部分隐藏*/
        white-space: nowrap; /*不换行*/
        text-overflow: ellipsis; /*超出部分文字以...显示*/
        .price-wrap {
          display: inline-block;
        }
        ::v-deep .price {
          color: #a37f23;
          font-size: 14px;
        }
      }
      &:first-child {
        background: #f0f0f0;
        font-weight: 500;
        border-radius: 8px 8px 0 0;
        color: #333;
        .vip-name {
          font-weight: 500;
          color: #333;
        }
        .vip-price {
          font-weight: 500;
          color: #333;
        }
      }
    }
  }
}
</style>
